// extracted by mini-css-extract-plugin
export default {"pageTitle":"roundPositionCell_pageTitle__WCnYL","roundPosition":"roundPositionCell_roundPosition__f1L9e"};